import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  AfterViewInit,
  ChangeDetectionStrategy,
} from "@angular/core";
import { AppsService } from "src/app/shared/services/apps.service";
import { FormBuilder, FormGroup, FormControl } from "@angular/forms";
import { NzModalService } from "ng-zorro-antd/modal";
import _moment from "moment";
import { ActivatedRoute, Router } from "@angular/router";
import { NzMessageService } from "ng-zorro-antd/message";
import { Subject, Subscription } from "rxjs";
import { takeUntil } from "rxjs/operators";
const moment = _moment;
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { DatePipe } from "@angular/common";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
// SECURITY (audit finding #9 - Formula Injection, CWE-1236)
import { sanitizeRows } from "src/app/shared/utils/sanitize-export";
import "src/app/shared/utils/jspdf-autotable";
import { jsPDF } from "jspdf";
import { AddVehicleDeviceComponent } from "./add-vehicle-device/add-vehicle-device.component";
@Component({
  selector: "app-ams-vehicles",
  templateUrl: "./ams-vehicles.component.html",
  styleUrls: ["./ams-vehicles.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AmsVehiclesComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild("categoryStrip", { static: false })
  categoryStripElement: ElementRef;
  /** Add New Vehicle / Add New Device drawers (shared with the Add Vehicle page). */
  @ViewChild("vhclFrms", { static: false }) vhclFrms: AddVehicleDeviceComponent;
  /** Client the drawers should default to. */
  clntId: any;
  canScrollLeft = false;
  canScrollRight = true;
  header_label = {
    name: "Vehicles",
  };
  searchText;
  crdsview: boolean;
  tblview: boolean;
  shwttlvhcle = false;
  switchValue = false;
  filterPanelOpen = true;
  vhcleslst: any = [];
  activeStatusCard: string = "";
  activeLocationCard: string = "";
  activeCategoryKey: number = 0;
  visible = false;
  driverform: FormGroup;
  selectedValue;
  drvrslst: any;
  vhcledtls = false;
  warddtls = false;
  drvrasgn = false;
  vhclenumbr: any;
  crw_id;
  trpslst: any;
  vhcldtlsform: FormGroup;
  warddtlsform: FormGroup;
  dte: any;
  trp_nu: any;
  asert_id: any;
  asgndrvrs: any;
  tntLst: any = [];
  clntDtls: any;
  selectedtenant;
  vendorList: any = [];
  selectedvndr;
  selectedctgry;
  vehctgryLst: any = [];
  wrdlst: any = [];
  cardcntSummary: any = [];
  totveh: number;
  USER_PERMISSIONS: any = {
    slct_in: 0,
    insrt_in: 0,
    updt_in: 0,
    dlte_in: 0,
    exprt_in: 0,
  };
  /* Set true when getVhclsLst returns 404 (vldSelect('assetTracking')
     denied). Template shows an access-denied placeholder in place of
     the vehicle list — mirrors the pattern in asset-types.component.ts. */
  usrAcsErrMsg: boolean = false;
  vhcleGrp: any;
  vehicleSts: any;
  wardSts: any;
  vhcleDprtmnt: any;
  asrt_sts_data: any = [];
  selectedSts: any;
  asrt_id: any;
  params: any;
  navData: any = [];
  vhclslstcolumnDefs: any = [];
  showLdr = false;
  visibleVhclSldr = false;
  VhclSldr: boolean;
  url: string;
  url2: string;
  urlSafe: SafeResourceUrl;
  urlSafe2: SafeResourceUrl;
  pbckData: any = {};
  userDtls: any;
  showVndr: boolean = false;
  clap_in: any;
  ShowClap: boolean = false;
  errmsg: any;
  selectedGrp: any;
  fncsLst: any[];
  slctdDt = new Date();
  curDate: string;
  timeFormat = "HH:mm";
  strt_tm = new Date();
  fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  fileExtension = ".xlsx";
  urban_in: any;
  hdrLbl: string;
  crdChnge: boolean;
  asrt_sts_id: any;
  ctgryCardcntSummary: any;
  allCategories: any;
  prkd_veh_ct = 0;
  rn_veh_ct = 0;
  vhclLctnCnts: any;
  currentTimeStmp: string;
  recievedTime: string;
  diffTimeInMin: number;
  slctdctgry: any;
  slctdLctn: any;
  sts_data: any = [];
  vehDupLst: any;
  rn_data: any[];
  prkd_data: any[];
  sts_cd: any;
  slctctgryNm: any;
  ctgryData: any;
  todte: any;
  // Separate arrays for parking status and parking location
  parkingStatusCards: any[] = [];
  parkingLocationCards: any[] = [];
  currentPage: number = 1;
  totalVehicles: number = 0;
  pageSize: number = 24;
  serverRunningCt: number = 0;
  serverParkedCt: number = 0;
  serverVehYardCt: number = 0;
  serverDumpYardCt: number = 0;
  serverOthersCt: number = 0;
  parkingFilter: string = "";
  locationFilter: string = "";
  private searchDebounceTimer: any;
  private subscriptions: Subscription[] = [];
  private resizeListener: (() => void) | null = null;
  private destroy$ = new Subject<void>();
  fromUrbanDashboard: boolean = false;

  constructor(
    private apiSrvc: AppsService,
    private modal: NzModalService,
    private router: Router,
    private message: NzMessageService,
    private route: ActivatedRoute,
    public sanitizer: DomSanitizer,
    public datepipe: DatePipe
  ) {
    this.clntDtls = JSON.parse(localStorage.getItem("wto_clients"));
    // console.log(this.clntDtls.clnt_id)
    this.tntLst = this.clntDtls[0].tnts;
    this.userDtls = JSON.parse(localStorage.getItem("wto_w_user"));
    // console.log(this.userDtls);
    this.clntId =
      this.userDtls && this.userDtls.clnt_id
        ? this.userDtls.clnt_id
        : this.clntDtls[0].clnt_id;
    this.clap_in = this.userDtls.clap_in;
    if (this.clap_in == 1) {
      this.ShowClap = true;
      this.selectedvndr = 0;
    }
    const routeSub = this.route.queryParams.subscribe((params) => {
      this.params = params;
    });
    this.subscriptions.push(routeSub);
    if (this.params.data) {
      this.navData = JSON.parse(this.params.data);
      this.selectedtenant = this.navData.tnt_id;
      this.selectedvndr = this.navData.vndr_id;
      this.selectedctgry = this.navData.asrt_ctgry_id;
      this.urban_in = this.navData.urban_in;
    } else {
      this.navData = {};
      if (this.tntLst.length > 1) {
        this.selectedtenant = 0;
        this.urban_in = this.tntLst[0].urban_in;
      } else {
        this.selectedtenant = this.tntLst[0].tnt_id;
        this.urban_in = this.tntLst[0].urban_in;
      }
      this.selectedvndr = "";
      this.selectedctgry = "";
    }
    if (this.urban_in == 1) {
      this.hdrLbl = "ULB";
    } else {
      this.hdrLbl = "Mandal";
    }
  }

  ngOnInit() {
    this.fromUrbanDashboard =
      JSON.parse(localStorage.getItem("from_urban_dashboard")) === true;
    localStorage.setItem("from_urban_dashboard", JSON.stringify(false));
    this.selectedvndr = 0;
    this.selectedctgry = 0;
    this.activeCategoryKey = 0; // Initialize to match default selectedctgry
    // Initialize parking cards
    this.updateParkingCards();
    this.gridview();
    this.getDrvrsLst();
    this.getVhcleCtgry();
    this.getWardLst();
    this.getVendors();
    this.getCardsData();
    this.getvhcleGrp();
    this.getLocations();
    // this.selectedvndr = 0;
    // this.getTrpsLst(null);

    this.warddtlsform = new FormGroup({
      veh_nu: new FormControl(""),
      wrd_nm: new FormControl(""),
      wrd_sts: new FormControl(""),
    });

    this.vhcldtlsform = new FormGroup({
      veh_nu: new FormControl(""),
      veh_grp: new FormControl(""),
      veh_ctgry: new FormControl(""),
      //veh_dprtmnt: new FormControl(''),
      veh_sts: new FormControl(""),
      veh_trps: new FormControl(""),
      veh_spd: new FormControl(""),
      veh_dstnce: new FormControl(""),
      veh_stpg_tm: new FormControl(""),
      veh_mlge: new FormControl(""),
      veh_spare: new FormControl(""),
      hme_fnce_id: new FormControl(""),
      strt_tm: new FormControl(""),
      ntfy_intrvl_tm: new FormControl(""),
    });
  }

  getVhclsLst = () => {
    // console.log('getVhclsLst');
    this.showLdr = true;
    const fltrData = {};
    // console.log(this.navData);
    this.vhcleslst = [];
    if (this.navData.asrt_id) {
      if (this.navData.tnt_id && this.navData.tnt_id != 0) {
        // tslint:disable-next-line:no-string-literal
        fltrData["selectedtenant"] = this.navData.tnt_id;
      }
      if (this.navData.vndr_id) {
        // tslint:disable-next-line:no-string-literal
        fltrData["selectedvndr"] = this.navData.vndr_id;
      }
      if (this.navData.asrt_ctgry_id) {
        // tslint:disable-next-line:no-string-literal
        fltrData["selectedctgry"] = this.navData.asrt_ctgry_id;
      }
      if (this.navData.asrt_id) {
        fltrData["selectedAsrt"] = this.navData.asrt_id;
      }
    } else {
      // Always pass selectedtenant - 0 means all tenants
      fltrData["selectedtenant"] = this.selectedtenant || 0;
      if (this.selectedtenant == 0 || !this.selectedtenant) {
        fltrData["sts_cd"] = this.sts_cd;
      }
      if (this.clap_in == 1 && this.selectedvndr) {
        fltrData["selectedvndr"] = this.selectedvndr;
      } else {
        // tslint:disable-next-line:no-string-literal
        fltrData["selectedvndr"] = 0;
      }
      if (this.selectedctgry && this.selectedtenant != 0) {
        // tslint:disable-next-line:no-string-literal
        fltrData["selectedctgry"] = this.selectedctgry;
      } else if (this.selectedctgry == 0) {
        fltrData["selectedctgry"] = this.selectedctgry;
      } else if (
        this.selectedctgry != 0 &&
        this.selectedtenant == 0 &&
        this.slctctgryNm == null
      ) {
        fltrData["selectedctgry"] = this.selectedctgry;
      } else {
        fltrData["selectedctgrynm"] = this.slctctgryNm;
      }
      if (this.selectedtenant != 0 && this.asrt_sts_id) {
        // tslint:disable-next-line:no-string-literal
        fltrData["asrt_sts_id"] = this.asrt_sts_id;
      } else if (this.selectedtenant == 0 && this.asrt_sts_id) {
        fltrData["sts_cd"] = this.sts_cd;
      }
    }
    // Add server-side pagination params
    fltrData["page"] = this.currentPage;
    fltrData["pageSize"] = this.pageSize;
    fltrData["searchText"] = this.searchText || "";
    fltrData["parkingFilter"] = this.parkingFilter || "";
    fltrData["locationFilter"] = this.locationFilter || "";

    console.log(fltrData);
    this.usrAcsErrMsg = false;
    this.apiSrvc
      .post(fltrData, "drivers/vehicles/vehicles")
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          /* 404 = ACCESS_DENIED from vldSelect('assetTracking') — the user has
         no slct_in on the assetTracking object. Flip the flag the template
         uses to render an "access denied" placeholder in place of the list. */
          if (res["status"] == 404) {
            this.usrAcsErrMsg = true;
            this.showLdr = false;
            this.vhcleslst = [];
            this.totalVehicles = 0;
            return;
          }
          if (res["status"] == 200) {
            /* Capture role→object permissions attached by vldSelect middleware.
           Template gates Ward + Edit (update-only actions) on updt_in;
           View (eye) stays visible for all users with slct_in. Falls back
           to the default (no-write) shape when perm is absent so a legacy
           unpatched backend response won't accidentally show edit icons. */
            if (res["perm"] && res["perm"][0]) {
              this.USER_PERMISSIONS = res["perm"][0];
            }
            var resData = res["data"];
            // Handle paginated response format
            if (!Array.isArray(resData) && resData.data) {
              this.vhcleslst = resData.data;
              this.totalVehicles = resData.total || 0;
              this.serverRunningCt = resData.running_ct || 0;
              this.serverParkedCt = resData.parked_ct || 0;
              this.serverVehYardCt = resData.veh_yard_ct || 0;
              this.serverDumpYardCt = resData.dump_yard_ct || 0;
              this.serverOthersCt = resData.others_ct || 0;
            } else {
              // Legacy array response
              this.vhcleslst = resData;
              this.totalVehicles = this.vhcleslst.length;
            }
            this.showLdr = false;
            console.log(this.vhcleslst);
            // console.log(this.vhcleslst);

            // Process each vehicle
            for (let v = 0; v < this.vhcleslst.length; v++) {
              // Set icon path based on status
              if (this.vhcleslst[v].asrtglblId === 1) {
                if (this.vhcleslst[v].spd_ct == 0) {
                  this.vhcleslst[v].icon_pathr =
                    this.vhcleslst[v].icon_path + "_p";
                } else {
                  this.vhcleslst[v].icon_pathr =
                    this.vhcleslst[v].icon_path + "_r";
                }
              } else if (this.vhcleslst[v].asrtglblId === 2) {
                this.vhcleslst[v].icon_pathr =
                  this.vhcleslst[v].icon_path + "_o";
              } else {
                // this.vhcleslst[v].icon_pathr = this.vhcleslst[v].icon_path + '_p';
                this.vhcleslst[v].icon_pathr =
                  this.vhcleslst[v].icon_path + "_o";
              }

              // Calculate time difference for each vehicle
              this.currentTimeStmp = moment(this.slctdDt).format(
                "YYYY-MM-DD HH:mm:ss"
              );
              this.recievedTime = moment(
                this.vhcleslst[v].data_received_ts
              ).format("YYYY-MM-DD HH:mm:ss");
              this.vhcleslst[v].diffTimeInMin = moment(
                this.currentTimeStmp
              ).diff(this.recievedTime, "minute");

              // Set ownership name based on asrt_ownr_id
              this.vhcleslst[v].ownership_nm =
                this.vhcleslst[v].asrt_ownr_id == 2 ? "Hired" : "Own";
            }

            // Set URL Safe values (only need to do this once)
            this.url =
              "http://vms.dreamstep.info/RlKd9ipWTb41Md6O4eZVNUxCZZDjgf/embed/l4aGwhaoRk/111/jquery|fullscreen";
            this.url2 =
              "http://vms.dreamstep.info/RlKd9ipWTb41Md6O4eZVNUxCZZDjgf/embed/l4aGwhaoRk/111/jquery|fullscreen";
            this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(
              this.url
            );
            this.urlSafe2 = this.sanitizer.bypassSecurityTrustResourceUrl(
              this.url2
            );
            this.vehDupLst = this.vhcleslst;
            // Update parking cards with server-side counts
            this.parkingStatusCards = [
              {
                type: "running",
                group: "status",
                label: "Running",
                value: this.serverRunningCt,
                hint: "Active on road",
              },
              {
                type: "parked",
                group: "status",
                label: "Parked",
                value: this.serverParkedCt,
                hint: "Stationary fleet",
              },
            ];
            this.parkingLocationCards = [
              {
                type: "veh_yard",
                group: "location",
                label: "Vehicle Yard",
                value: this.serverVehYardCt,
                hint: "At yard",
              },
              {
                type: "dump_yard",
                group: "location",
                label: "Dump Yard",
                value: this.serverDumpYardCt,
                hint: "Dumping site",
              },
              {
                type: "others",
                group: "location",
                label: "Others",
                value: this.serverOthersCt,
                hint: "Out on duty",
              },
            ];
            if (this.urban_in == 1) {
              this.vhclslstcolumnDefs = [
                {
                  headerName: "S.No",
                  field: "sno",
                  alignment: "center",
                  width: 100,
                  filter: false,
                },
                {
                  headerName: "District",
                  alignment: "center",
                  field: "district",
                },
                {
                  headerName: "ULB Name",
                  alignment: "center",
                  field: "tnt_nm",
                },
                {
                  headerName: "Vehicle No",
                  alignment: "left",
                  field: "asrt_nm",
                },
                {
                  headerName: "Ownership",
                  alignment: "center",
                  field: "ownership_nm",
                  width: 100,
                },
                {
                  headerName: "Category",
                  field: "asrt_ctgry_nm",
                  alignment: "left",
                },
                {
                  headerName: "Group",
                  alignment: "left",
                  field: "asrt_grp_nm",
                },
                {
                  headerName: "IMEI",
                  alignment: "center",
                  field: "dev_imei_nu",
                },
                // { headerName: 'Start Fence', alignment: 'center', field: 'startFence' },
                // { headerName: 'End Fence', field: 'endFence', alignment: 'center' }
              ];
            } else {
              this.vhclslstcolumnDefs = [
                {
                  headerName: "S.No",
                  field: "sno",
                  alignment: "center",
                  width: 100,
                  filter: false,
                },
                {
                  headerName: "Vehicle No",
                  alignment: "left",
                  field: "asrt_nm",
                },
                {
                  headerName: "Ownership",
                  alignment: "center",
                  field: "ownership_nm",
                  width: 100,
                },
                {
                  headerName: "District",
                  alignment: "center",
                  field: "district",
                },
                { headerName: "Mandal", alignment: "center", field: "tnt_nm" },
                {
                  headerName: "Village",
                  field: "asrt_grp_nm",
                  alignment: "left",
                },
                {
                  headerName: "Location",
                  alignment: "center",
                  field: "loc_nm",
                },
                {
                  headerName: "IMEI",
                  alignment: "center",
                  field: "dev_imei_nu",
                },
              ];
            }
          }
        },
        (err) => {
          // console.log(err);
        }
      );
  };

  getDrvrsLst = () => {
    const data = {};
    this.apiSrvc
      .post(data, "drivers/drivers")
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.drvrslst = res["data"];
        },
        (err) => {}
      );
  };

  getVhcleCtgry = () => {
    this.apiSrvc
      .get(`drivers/vehicles/category/${this.selectedtenant}`)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.vehctgryLst = res["data"];
          console.log(this.vehctgryLst);
        },
        (err) => {}
      );
  };
  getVhcleCtgrybygrp() {
    var asrt_data = {
      asrt_grp: this.selectedGrp,
    };
    this.apiSrvc
      .post(asrt_data, "playback/categories/assets")
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.vehctgryLst = res["data"];
          // console.log(this.vehctgryLst);
        },
        (err) => {}
      );
  }

  getWardLst = () => {
    this.apiSrvc
      .get(`drivers/vehicles/wards/${this.selectedtenant}`)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.wrdlst = res["data"];
        },
        (err) => {}
      );
  };

  gridview() {
    if (this.switchValue == false) {
      this.crdsview = true;
      this.tblview = false;
    } else if (this.switchValue == true) {
      this.crdsview = false;
      this.tblview = true;
    }
  }
  onDateChng() {
    this.dte = moment(this.dte).format("YYYY-MM-DD");
    let postdata = {
      asrt_id: this.asert_id,
      date: this.dte,
    };
    this.apiSrvc.put(postdata, `drivers/vehicle/trips`).subscribe(
      (res) => {
        this.trpslst = res["data"];
      },
      (err) => {
        // // console.log(err);
      }
    );
  }
  onToDateChng() {
    this.dte = moment(this.todte).format("YYYY-MM-DD");
  }

  openasigndrvrfrm(data) {
    console.log(data);
    this.crw_id = data.crw_id;
    this.drvrasgn = true;
    this.vhcledtls = false;
    this.visible = false;
    this.visible = true;
    this.asert_id = data.asrt_id;
    this.vhclenumbr = data.asrt_nm;
    this.asgnervrs();
  }
  closedrvrlst() {
    if (this.vhcledtls) {
      this.visible = false;
      this.vhcledtls = false;
      this.vhcldtlsform.reset();
    } else {
      this.closeDriverModal();
    }
  }

  closervrlst() {
    this.warddtls = false;
    this.warddtlsform.reset();
  }
  closeDriverModal() {
    this.drvrasgn = false;
    this.crw_id = null;
    this.trp_nu = null;
  }

  openvhcldtlsfrm(data) {
    this.drvrasgn = false;
    this.vhcledtls = true;
    this.visible = true;
    console.log(data);
    this.asrt_id = data.asrt_id;
    let sflck_ts = moment(data.sflck_nxt_chk_ts, "HH:mm");
    console.log(sflck_ts);
    this.selectedtenant = data.tntId;
    this.vhcldtlsform.get("veh_nu").setValue(data.asrt_nm);
    this.vhcldtlsform.get("veh_grp").setValue(data.asrt_grp_id);
    this.vhcldtlsform.get("veh_ctgry").setValue(data.asrt_ctgry_id);
    // this.vhcldtlsform.get('veh_dprtmnt').setValue(data.dprt_id);
    this.vhcldtlsform.get("veh_sts").setValue(data.crnt_ast_sts_id);
    this.vhcldtlsform.get("veh_trps").setValue(data.trgt_trps);
    this.vhcldtlsform.get("veh_spd").setValue(data.max_spd_lmt_ct);
    this.vhcldtlsform.get("veh_dstnce").setValue(data.max_dst);
    this.vhcldtlsform.get("veh_stpg_tm").setValue(data.unauth_range);
    this.vhcldtlsform.get("veh_mlge").setValue(data.mileage_ct);
    this.vhcldtlsform.get("veh_spare").setValue(data.asrt_spre_in);
    this.vhcldtlsform.get("hme_fnce_id").setValue(data.hme_fnce_id);
    this.vhcldtlsform.get("strt_tm").setValue(sflck_ts);
    this.vhcldtlsform.get("ntfy_intrvl_tm").setValue(data.ntfy_intrvl_tm);
    this.getvhcleGrp();
  }
  drvrasgndtls(data) {
    this.drvrasgn = true;
    this.vhcledtls = false;
    this.visible = true;
    this.warddtls = false;
    this.asrt_id = data.asrt_id;
    this.asert_id = data.asrt_id;
    this.vhclenumbr = data.asrt_nm;
    this.asgnervrs();
  }
  openwardlstfrm(data) {
    this.drvrasgn = false;
    this.vhcledtls = false;
    this.warddtls = true;
    this.visible = true;
    this.asrt_id = data.asrt_id;
    this.warddtlsform.get("veh_nu").setValue(data.asrt_nm);
    this.warddtlsform.get("wrd_nm").setValue(data.wrd_id);
    this.warddtlsform.get("wrd_sts").setValue(data.asrt_sts_id);
  }

  saveasgnmnt() {
    if (
      this.asert_id !== undefined &&
      this.dte !== undefined &&
      this.crw_id !== undefined
    ) {
      let postdata = {
        vhclnm: this.asert_id,
        dte: this.dte,
        trp_num: this.trp_nu,
        crw_id: this.crw_id,
        tnt_id: this.selectedtenant,
      };
      // console.log(postdata)
      this.apiSrvc
        .put(postdata, "drivers/drivers/wbtripassign")
        .subscribe((res) => {
          if (res["status"] === 200) {
            this.closeDriverModal();
            this.modal.success({
              nzTitle: "Driver Details",
              nzContent: "Sucessfully Updated",
            });
            this.asgnervrs();
          }
        });
    } else {
    }
  }

  asgnervrs() {
    this.apiSrvc.get("drivers/drivers/asgnedrvrs/" + this.asert_id).subscribe(
      (res) => {
        this.asgndrvrs = res["data"];
      },
      (err) => {}
    );
  }
  updateVehicleData() {
    // console.log(this.vhcldtlsform);
    var sts = this.vhcldtlsform.value.veh_sts;
    this.vehicleSts.filter((k) => {
      if (k.asrt_sts_id == sts) {
        this.asrt_sts_data.push(k);
      }
    });
    console.log(this.vhcldtlsform.value.strt_tm);
    var postData = {
      asrt_id: this.asrt_id,
      asrt_nm: this.vhcldtlsform.value.veh_nu,
      asrt_ctgry_id: this.vhcldtlsform.value.veh_ctgry,
      asrt_grp_id: this.vhcldtlsform.value.veh_grp,
      dprt_id: 0,
      bnch_dst: this.vhcldtlsform.value.veh_dstnce,
      bnch_trps: this.vhcldtlsform.value.veh_trps,
      bnch_spd: this.vhcldtlsform.value.veh_spd,
      unauth_tm: this.vhcldtlsform.value.veh_stpg_tm,
      milage: this.vhcldtlsform.value.veh_mlge,
      asrt_ownr_id: 1,
      asrt_sts_id: this.vhcldtlsform.value.veh_sts,
      //"asrt_glbl_sts_id":this.asrt_sts_data[0].asrt_glbl_sts_id,
      tnt_id: this.selectedtenant,
      hme_fnce_id: this.vhcldtlsform.value.hme_fnce_id,
      strt_tm: this.vhcldtlsform.value.strt_tm,
      ntfy_intrvl_tm: this.vhcldtlsform.value.ntfy_intrvl_tm,
    };
    console.log(postData);
    this.apiSrvc.post(postData, "drivers/vehicles/update").subscribe((res) => {
      if (res["status"] == 200) {
        this.createMessage("Success", "Vehicle successfully Updated");
        this.getVhclsLst();
      }
    });
  }

  updateWardData() {
    // console.log( this.warddtlsform.value.wrd_nm)
    // console.log(this.asrt_id)
    let data = {
      wrd_id: this.warddtlsform.value.wrd_nm,
      asrt_id: this.asrt_id,
    };
    this.apiSrvc.post(data, `drivers/vehicles/updateWard`).subscribe((res) => {
      if (res["status"] == 200) {
        this.createMessage("Success", "Ward details Updated");
      }
    });
    this.warddtls = false;
    this.warddtlsform.reset();
  }
  ontntSelect(value) {
    // if (value == 0) {
    //   this.selectedctgry = 0
    // }
    // else {
    //   this.selectedctgry = null
    // }
    this.selectedctgry = 0;
    console.log(this.selectedctgry);
    this.selectedtenant = value;
    this.tntLst.forEach((element) => {
      if (element.tnt_id == this.selectedtenant) {
        this.urban_in = element.urban_in;
      }
    });
    if (this.urban_in == 1) {
      this.hdrLbl = "ULB";
    } else {
      this.hdrLbl = "Mandal";
    }
    this.navData = {};
    this.getVendors();
    this.getVhclsLst();
    this.getvhcleGrp();
    this.getVhcleCtgry();
    this.getCardsData();
    this.getLocations();
  }
  getVendors() {
    console.log(this.userDtls.dsgns_id);
    if (this.userDtls.dsgns_id == 1000032) {
      this.selectedvndr = this.userDtls.vndr_id;
      this.showVndr = true;
      if (this.selectedvndr && this.showVndr) {
        this.apiSrvc
          .get(`billing/vendors/list/${this.selectedvndr}/byId`)
          .pipe(takeUntil(this.destroy$))
          .subscribe(
            (res) => {
              // console.log(res)
              if (res["status"] == 200) {
                this.vendorList = res["data"];
              }
            },
            (err) => {
              // console.log("In errorr");
            }
          );
      }
    } else if (this.clap_in == 0 || this.clap_in == 2) {
      this.vendorList = [];
      this.selectedvndr = 0;
      this.getVhclsLst();
    } else {
      this.apiSrvc
        .get(`billing/vehicle-wise/vendors/list/${this.selectedtenant}`)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (res) => {
            if (res["status"] === 200) {
              this.vendorList = res["data"];
              // this.USER_PERMISSIONS = res['perm'][0];
              if (this.vendorList.length > 1) {
                this.selectedvndr = 0;
              } else {
                this.selectedvndr = this.vendorList[0].vndr_id;
              }
              this.getVhclsLst();
              this.getCardsData();
            }
          },
          (err) => {
            // // console.log('In errorr');
          }
        );
    }
  }
  getvhcleGrp() {
    this.apiSrvc
      .get(`drivers/vehicles/group/${this.selectedtenant}`)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.vhcleGrp = res["data"];
          // console.log(this.vhcleGrp)
        },
        (err) => {}
      );
    this.apiSrvc
      .get(`drivers/vehicles/departments/${this.selectedtenant}`)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.vhcleDprtmnt = res["data"];
          // console.log(this.vhcleDprtmnt)
        },
        (err) => {}
      );

    this.apiSrvc
      .get(`drivers/vehicles/status/${this.selectedtenant}`)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.vehicleSts = res["data"];
          // console.log(this.vehicleSts)
        },
        (err) => {}
      );
  }
  onvndrSelect(value) {
    this.selectedvndr = value;
    this.navData = {};
    this.getVhclsLst();
    this.getCardsData();
    this.shwttlvhcle = true;
  }

  onctgrySelect(value) {
    // console.log(value)
    // if(typeof value === 'string'){
    //   this.ctgryData = value.split('/');
    //   this.selectedctgry =Number(this.ctgryData[0]);
    //   this.slctctgryNm =this.ctgryData[1]
    // }
    // else{
    //   this.selectedctgry=value.asrt_ctgry_id
    //   this.slctctgryNm=value.asrt_ctgry_nm
    // }

    // Reset parking status filters when changing category
    this.activeStatusCard = "";
    this.activeLocationCard = "";
    this.parkingFilter = "";
    this.locationFilter = "";
    this.currentPage = 1;

    if (value.asrt_ctgry_id) {
      this.selectedctgry = value.asrt_ctgry_id;
      this.slctctgryNm = value.asrt_ctgry_nm;
      // Sync activeCategoryKey when category is selected
      this.activeCategoryKey = value.asrt_ctgry_id;
    } else {
      this.selectedctgry = value;
      this.slctctgryNm = null;
      // Sync activeCategoryKey when category is selected by ID
      this.activeCategoryKey = value;
    }

    console.log(this.selectedctgry, this.slctctgryNm);
    console.log(this.ctgryCardcntSummary);
    this.navData = {};
    // Update crdChnge flags for chips
    if (this.ctgryCardcntSummary) {
      this.ctgryCardcntSummary.forEach((e) => {
        const categoryId = value.asrt_ctgry_id || value;
        if (e.asrt_ctgry_id == categoryId) {
          e.crdChnge = true;
        } else {
          e.crdChnge = false;
        }
      });
    }

    this.getVhclsLst();
    this.getCardsData();
  }

  onCardSelect() {
    this.selectedctgry = 0;
    this.activeCategoryKey = 0; // Sync activeCategoryKey when resetting to "All"
    // Reset parking status and location filters
    this.activeStatusCard = "";
    this.activeLocationCard = "";
    this.parkingFilter = "";
    this.locationFilter = "";
    this.currentPage = 1;
    this.getCardsData();
    this.getVhclsLst();
  }

  onvehGrpSelect(value) {
    this.selectedGrp = value;
    this.getVhcleCtgrybygrp();
  }

  getCardsData() {
    // console.log(this.selectedctgry);
    // if(this.selectedvndr){
    this.apiSrvc
      .get(
        `drivers/vehicle-wise/cards/summary/${this.selectedvndr}/${this.selectedtenant}/${this.selectedctgry}/${this.slctctgryNm}`
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        // console.log(res)
        if (res["status"] == 200) {
          this.cardcntSummary = res["data"];
          console.log(this.cardcntSummary);
          this.asrt_sts_id = this.cardcntSummary[0].asrt_sts_id;
          this.cardcntSummary[0].crdChnge = true;
          this.getVhclsLst();
          // this.shwttlvhcle = true;
          // this.totveh = this.cardcntSummary[0].tot_veh;
          // console.log(this.totveh)
        }
      });
    this.apiSrvc
      .get(
        `drivers/vehicle-wise/ctgry/summary/${this.selectedvndr}/${this.selectedtenant}`
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        if (res["status"] == 200) {
          this.ctgryCardcntSummary = res["data"];
          console.log(this.ctgryCardcntSummary);
          // this.selectedctgry=this.ctgryCardcntSummary[0].asrt_ctgry_id;
          if (this.ctgryCardcntSummary[0]) {
            this.ctgryCardcntSummary[0].crdChnge = true;
          }
          setTimeout(() => this.updateScrollButtons(), 200);
        }
      });
    console.log(this.slctctgryNm);
    this.apiSrvc
      .get(
        `drivers/vehicle-wise/lctns/summary/${this.selectedvndr}/${this.selectedtenant}/${this.selectedctgry} /${this.slctctgryNm}`
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        if (res["status"] == 200) {
          this.vhclLctnCnts = res["data"];
          console.log(this.vhclLctnCnts);
          this.vhclLctnCnts[0].crdChnge = true;
          // Update parking cards when location counts are loaded
          this.updateParkingCards();
        }
      });
    // }else{
    //   this.errmsg="No Vehicles found !!!";
    // }

    this.apiSrvc
      .get(`drivers/vehicle-wise/all-ctgry/summary/${this.selectedtenant}`)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        if (res["status"] == 200) {
          this.allCategories = res["data"];
          console.log(res["data"]);
          this.allCategories[0].crdChnge = true;
          console.log(this.allCategories);
          setTimeout(() => this.updateScrollButtons(), 200);
        }
      });
  }
  // Classify a vehicle into one of the 3 location buckets
  private classifyVehicleLocation(
    vehicle: any
  ): "dump_yard" | "veh_yard" | "others" {
    const vehicleLoc = (vehicle.loc_nm || vehicle.curr_loc || "").toLowerCase();
    // Check dump yard FIRST to avoid overlap (e.g. "dump yard" contains "yard")
    if (
      vehicleLoc.includes("dump") ||
      vehicleLoc.includes("dumping") ||
      vehicleLoc.includes("landfill")
    ) {
      return "dump_yard";
    }
    if (
      vehicleLoc.includes("yard") ||
      vehicleLoc.includes("depot") ||
      vehicleLoc.includes("garage")
    ) {
      return "veh_yard";
    }
    return "others";
  }

  onLctnSlct(locationData) {
    if (!locationData || !this.vehDupLst) {
      this.vhcleslst = this.vehDupLst || [];
      return;
    }

    const locationType = locationData.type || locationData.location_type;
    const filteredData = [];

    this.vehDupLst.forEach((vehicle) => {
      const bucket = this.classifyVehicleLocation(vehicle);
      if (locationType === "veh_yard" || locationType === "vehicle_yard") {
        if (bucket === "veh_yard") filteredData.push(vehicle);
      } else if (
        locationType === "dump_yard" ||
        locationType === "dumping_yard"
      ) {
        if (bucket === "dump_yard") filteredData.push(vehicle);
      } else if (locationType === "others") {
        if (bucket === "others") filteredData.push(vehicle);
      }
    });

    this.vhcleslst = filteredData;
  }

  // Recalculate location counts client-side so 3 buckets always sum to total
  private recalculateLocationCounts(): void {
    let vehYardCount = 0;
    let dumpYardCount = 0;
    let othersCount = 0;

    if (this.vehDupLst && this.vehDupLst.length > 0) {
      this.vehDupLst.forEach((vehicle) => {
        const bucket = this.classifyVehicleLocation(vehicle);
        if (bucket === "dump_yard") dumpYardCount++;
        else if (bucket === "veh_yard") vehYardCount++;
        else othersCount++;
      });
    }

    // Update parking location cards with client-side counts
    this.parkingLocationCards = [
      {
        type: "veh_yard",
        group: "location",
        label: "Vehicle Yard",
        value: vehYardCount,
        hint: "At yard",
      },
      {
        type: "dump_yard",
        group: "location",
        label: "Dump Yard",
        value: dumpYardCount,
        hint: "Dumping site",
      },
      {
        type: "others",
        group: "location",
        label: "Others",
        value: othersCount,
        hint: "Out on duty",
      },
    ];
  }
  gotovehcleDashboard(evnt) {
    this.router.navigate(["/internal/dashboard/vehicle-dashboard"], {
      queryParams: {
        asrt_id: JSON.stringify(evnt.asrt_id),
      },
    });
  }

  // Method to recalculate parking status counts based on current filtered vehicles
  recalculateParkingStatusCounts() {
    this.rn_veh_ct = 0;
    this.prkd_veh_ct = 0;

    if (this.vehDupLst && this.vehDupLst.length > 0) {
      this.vehDupLst.forEach((v) => {
        // Count running vehicles: speed > 0 and data received within last 5 minutes
        if (v.spd_ct != 0 && v.spd_ct != undefined && v.diffTimeInMin < 5) {
          this.rn_veh_ct++;
        } else {
          this.prkd_veh_ct++;
        }
      });
    }
    console.log(
      "Recalculated parking counts - Running:",
      this.rn_veh_ct,
      "Parked:",
      this.prkd_veh_ct
    );

    // Update parking cards with new counts
    this.updateParkingCards();
  }

  rnSlct() {
    this.rn_data = [];
    console.log("Running vehicles filter - vehDupLst:", this.vehDupLst);
    if (this.vehDupLst && this.vehDupLst.length > 0) {
      this.vehDupLst.forEach((e) => {
        // Match the exact count calculation logic: spd_ct != 0 && spd_ct != undefined && diffTimeInMin < 5
        if (e.spd_ct != 0 && e.spd_ct != undefined && e.diffTimeInMin < 5) {
          this.rn_data.push(e);
        }
      });
      this.vhcleslst = [...this.rn_data];
      console.log(
        "Filtered running vehicles:",
        this.rn_data.length,
        "Expected count:",
        this.rn_veh_ct
      );
    } else {
      this.vhcleslst = [];
    }
  }

  prkdSlct() {
    this.prkd_data = [];
    console.log("Parked vehicles filter - vehDupLst:", this.vehDupLst);
    if (this.vehDupLst && this.vehDupLst.length > 0) {
      this.vehDupLst.forEach((e) => {
        // Match the exact count calculation logic: everything that's NOT running
        // Running condition: spd_ct != 0 && spd_ct != undefined && diffTimeInMin < 5
        // Parked condition: NOT (spd_ct != 0 && spd_ct != undefined && diffTimeInMin < 5)
        // Which means: spd_ct == 0 OR spd_ct == undefined OR diffTimeInMin >= 5
        if (!(e.spd_ct != 0 && e.spd_ct != undefined && e.diffTimeInMin < 5)) {
          this.prkd_data.push(e);
        }
      });
      this.vhcleslst = [...this.prkd_data];
      console.log(
        "Filtered parked vehicles:",
        this.prkd_data.length,
        "Expected count:",
        this.prkd_veh_ct
      );
    } else {
      this.vhcleslst = [];
    }
  }

  onstatusChange(value) {
    this.selectedSts = value;
    this.vehicleSts.filter((k) => {
      if (k.asrt_sts_id == this.selectedSts) {
        this.asrt_sts_data.push(k);
      }
    });
  }
  createMessage(type: string, msg: string): void {
    this.message.create(type, msg);
  }

  selectedVehicle;
  toggleFilterPanel(forceState?: boolean) {
    this.filterPanelOpen =
      forceState !== undefined ? forceState : !this.filterPanelOpen;
  }

  /** Header action - open the "Add New Vehicle" drawer. */
  openAddVehicle() {
    this.vhclFrms.openVehicle("new");
  }

  /** Header action - open the "Add New Device" drawer. */
  openAddDevice() {
    this.vhclFrms.openDevice();
  }

  /** A vehicle/device was saved in the drawers - refresh counters and the list. */
  onVhclSaved() {
    this.getCardsData();
  }

  closeFilterPanel() {
    this.filterPanelOpen = false;
  }
  onFilterSwitchChange(state: boolean) {
    this.toggleFilterPanel(state);
  }
  onFilterULBChange(value: number) {
    this.selectedtenant = value === 0 ? 0 : value;
    this.ontntSelect(value);
  }
  onFilterCategoryChange(value: number) {
    this.selectedctgry = value === 0 ? 0 : value;
    // Update activeCategoryKey to sync with dropdown selection
    this.activeCategoryKey = value;

    if (value === 0) {
      // If "All" is selected, show all categories and reset to default view
      this.onCardSelect();
    } else {
      // If specific category is selected, filter to that category
      // Find the category in ctgryCardcntSummary to match chip structure
      const selectedCategory = this.ctgryCardcntSummary?.find(
        (cat: any) => cat.asrt_ctgry_id === value
      );
      if (selectedCategory) {
        this.onctgrySelect(selectedCategory);
      } else {
        // Fallback: try to find in vehctgryLst and create a matching object
        const categoryFromList = this.vehctgryLst.find(
          (cat: any) => cat.asrt_ctgry_id === value
        );
        if (categoryFromList) {
          this.onctgrySelect(categoryFromList);
        }
      }
    }
  }
  onFilterSearchChange(value: string) {
    this.searchText = value;
    // Debounced server-side search
    if (this.searchDebounceTimer) {
      clearTimeout(this.searchDebounceTimer);
    }
    this.searchDebounceTimer = setTimeout(() => {
      this.currentPage = 1;
      this.getVhclsLst();
    }, 400);
  }
  resetFilters() {
    // Reset filter values
    this.selectedtenant = 0;
    this.selectedctgry = 0;
    this.searchText = "";
    // Reset and reload data by calling select methods with 0 (All)
    if (this.tntLst.length > 1) {
      this.ontntSelect(0);
    }
    this.onctgrySelect(0);
  }
  applyFilters() {
    // Apply filters and close panel
    if (this.selectedtenant && this.selectedtenant !== 0) {
      this.ontntSelect(this.selectedtenant);
    }
    if (this.selectedctgry && this.selectedctgry !== 0) {
      this.onctgrySelect(this.selectedctgry);
    }
    this.closeFilterPanel();
  }
  get categoryChips() {
    // Always show all chips (not filtered by dropdown selection)
    const chips = this.ctgryCardcntSummary ? [...this.ctgryCardcntSummary] : [];
    if (this.allCategories && this.allCategories.length) {
      const allChip = {
        ...this.allCategories[0],
        asrt_ctgry_id: 0,
        asrt_ctgry_nm: "All Categories",
        ct: this.allCategories[0].ct ?? 0,
        isAll: true,
      };
      chips.unshift(allChip);
    }
    return chips;
  }

  // Getter for dropdown options with counts (duplicate of categoryChips)
  get categoryFilterOptions() {
    // Return the same structure as categoryChips for the dropdown
    return this.categoryChips;
  }
  isCategoryActive(chip): boolean {
    const chipId = chip.asrt_ctgry_id || (chip.isAll ? 0 : null);
    return chipId === this.activeCategoryKey;
  }

  trackByChipId(index: number, chip: any): any {
    return chip.asrt_ctgry_id || (chip.isAll ? 0 : `chip-${index}`);
  }
  handleCategoryChipSelect(chip, event?: Event) {
    // Prevent any event propagation issues
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    // Ensure activeCategoryKey is updated - handle both regular chips and "All Categories" chip
    const chipId =
      chip.asrt_ctgry_id !== undefined
        ? chip.asrt_ctgry_id
        : chip.isAll
        ? 0
        : null;
    this.activeCategoryKey =
      chipId !== null && chipId !== undefined ? chipId : 0;

    // Don't change the category filter dropdown when clicking chips
    // Only update the active chip and filter vehicles

    if (chipId === 0 || chip.isAll) {
      this.onCardSelect();
    } else {
      this.onctgrySelect(chip);
    }
  }
  // Method to update parking status and location cards
  updateParkingCards() {
    const location =
      this.vhclLctnCnts && this.vhclLctnCnts.length ? this.vhclLctnCnts[0] : {};

    // Update parking status cards (Running/Parked)
    this.parkingStatusCards = [
      {
        type: "running",
        group: "status",
        label: "Running",
        value: this.rn_veh_ct || 0,
        hint: "Active on road",
      },
      {
        type: "parked",
        group: "status",
        label: "Parked",
        value: this.prkd_veh_ct || 0,
        hint: "Stationary fleet",
      },
    ];

    // Update parking location cards (Vehicle Yard/Dump Yard/Others)
    this.parkingLocationCards = [
      {
        type: "veh_yard",
        group: "location",
        label: "Vehicle Yard",
        value: location?.Veh_Vhyrd || 0,
        hint: "At yard",
        payload: location,
      },
      {
        type: "dump_yard",
        group: "location",
        label: "Dump Yard",
        value: location?.Veh_dmpyrd || 0,
        hint: "Dumping site",
        payload: location,
      },
      {
        type: "others",
        group: "location",
        label: "Others",
        value: location?.Veh_othr || 0,
        hint: "Out on duty",
        payload: location,
      },
    ];

    console.log(
      "Parking cards updated - Status:",
      this.parkingStatusCards,
      "Location:",
      this.parkingLocationCards
    );
  }

  getTotalPages(): number {
    if (this.pageSize <= 0) return 1;
    return Math.max(1, Math.ceil(this.totalVehicles / this.pageSize));
  }

  getPageNumbers(): number[] {
    const total = this.getTotalPages();
    if (total <= 7) {
      return Array.from({ length: total }, (_, i) => i + 1);
    }
    const pages: number[] = [1];
    let start = Math.max(2, this.currentPage - 1);
    let end = Math.min(total - 1, this.currentPage + 1);
    if (start > 2) pages.push(-1);
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    if (end < total - 1) pages.push(-1);
    pages.push(total);
    return pages;
  }

  onPageChange(page: number) {
    if (page < 1 || page > this.getTotalPages()) return;
    this.currentPage = page;
    this.getVhclsLst();
  }

  get filteredVehicles() {
    // Return the current vehicles list (already filtered by parking status/location)
    // The search text filter is applied in the template via the pipe
    return this.vhcleslst || [];
  }
  // Separate handler for parking status (Running/Parked) - server-side filtering
  handleParkingStatusCard(card) {
    if (this.activeStatusCard === card.type) {
      // Toggle off - reset filter
      this.activeStatusCard = "";
      this.parkingFilter = "";
    } else {
      this.activeStatusCard = card.type;
      this.parkingFilter = card.type;
      this.activeLocationCard = "";
      this.locationFilter = "";
    }
    this.currentPage = 1;
    this.getVhclsLst();
  }

  // Separate handler for parking location (Vehicle Yard/Dump Yard/Others) - server-side filtering
  handleParkingLocationCard(card) {
    if (this.activeLocationCard === card.type) {
      // Toggle off - reset filter
      this.activeLocationCard = "";
      this.locationFilter = "";
    } else {
      this.activeLocationCard = card.type;
      this.locationFilter = card.type;
      this.activeStatusCard = "";
      this.parkingFilter = "";
    }
    this.currentPage = 1;
    this.getVhclsLst();
  }
  // Check if parking status card is active (Running/Parked)
  isParkingStatusActive(card): boolean {
    return this.activeStatusCard === card.type;
  }

  // Check if parking location card is active (Vehicle Yard/Dump Yard/Others)
  isParkingLocationActive(card): boolean {
    return this.activeLocationCard === card.type;
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.attachCategoryScrollListener();
      this.updateScrollButtons();
    }, 120);
    this.resizeListener = () => this.updateScrollButtons();
    window.addEventListener("resize", this.resizeListener);
  }
  private attachCategoryScrollListener() {
    if (!this.categoryStripElement) {
      return;
    }
    const scrollContainer = this.categoryStripElement.nativeElement;
    if (!scrollContainer) {
      return;
    }
    scrollContainer.addEventListener("scroll", () => {
      this.updateScrollButtons();
    });
  }
  scrollCategories(direction: "left" | "right") {
    if (!this.categoryStripElement) {
      return;
    }
    const scrollContainer = this.categoryStripElement.nativeElement;
    if (!scrollContainer) {
      return;
    }

    const scrollAmount = 200;
    const currentScroll = scrollContainer.scrollLeft;
    const newScroll =
      direction === "left"
        ? Math.max(0, currentScroll - scrollAmount)
        : currentScroll + scrollAmount;

    scrollContainer.scrollTo({
      left: newScroll,
      behavior: "smooth",
    });

    // Update button states after scroll
    setTimeout(() => {
      this.updateScrollButtons();
    }, 300);
  }
  updateScrollButtons() {
    if (!this.categoryStripElement) {
      return;
    }
    const scrollContainer = this.categoryStripElement.nativeElement;
    if (!scrollContainer) {
      return;
    }

    const { scrollLeft, scrollWidth, clientWidth } = scrollContainer;
    const maxScroll = scrollWidth - clientWidth;

    this.canScrollLeft = scrollLeft > 5; // Small threshold for better UX
    this.canScrollRight = scrollLeft < maxScroll - 5;
  }
  setView(mode: "cards" | "table") {
    this.switchValue = mode === "table";
    this.pageSize = mode === "table" ? 0 : 24;
    this.currentPage = 1;
    this.gridview();
    this.getVhclsLst();
  }
  handleVehicleSelect(vehicle, ev?: MouseEvent) {
    if (ev) {
      ev.stopPropagation();
    }
    this.selectedVehicle = vehicle;
  }
  getVehDashSldr(evnt) {
    this.gotovehcleDashboard(evnt);
  }
  closeVehicleSlider() {
    this.visibleVhclSldr = false;
  }
  hasActiveFilters(): boolean {
    return (
      !!(this.selectedtenant && this.selectedtenant !== 0) ||
      !!(this.selectedvndr && this.selectedvndr !== 0) ||
      !!(this.selectedctgry && this.selectedctgry !== 0) ||
      !!(this.searchText && this.searchText.trim() !== "")
    );
  }
  getActiveFilterCount(): number {
    let count = 0;
    if (this.selectedtenant && this.selectedtenant !== 0) count++;
    if (this.selectedvndr && this.selectedvndr !== 0) count++;
    if (this.selectedctgry && this.selectedctgry !== 0) count++;
    if (this.searchText && this.searchText.trim() !== "") count++;
    return count;
  }
  resumeSlider() {
    if (!this.selectedVehicle) {
      this.message.info("Select a vehicle card to open the slider.");
      return;
    }
    this.visibleVhclSldr = true;
  }
  openslider(evt) {
    this.VhclSldr = true;
    this.pbckData = evt;
    // console.log(this.pbckData)
  }
  // fullscreen(id, url) {
  //   if (id == 1) {
  //     window.open(url);
  //   } else {
  //     window.open(url);

  //   }
  // }
  goToLink(url: string) {
    window.open(url, "_blank");
  }
  getLocations() {
    this.fncsLst = [];
    this.apiSrvc
      .get(`geo/locations/list/${this.selectedtenant}`)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        // console.log(res)
        if (res["status"] == 200) {
          this.fncsLst = res["data"];
        }
      });
  }
  onChange(e): void {
    this.slctdDt = e;
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
  }
  exlArry = [];
  fetchAllVehicles(callback: (vehicles: any[]) => void) {
    const fltrData = {};
    if (this.navData.asrt_id) {
      if (this.navData.tnt_id && this.navData.tnt_id != 0) {
        fltrData["selectedtenant"] = this.navData.tnt_id;
      }
      if (this.navData.vndr_id) {
        fltrData["selectedvndr"] = this.navData.vndr_id;
      }
      if (this.navData.asrt_ctgry_id) {
        fltrData["selectedctgry"] = this.navData.asrt_ctgry_id;
      }
      if (this.navData.asrt_id) {
        fltrData["selectedAsrt"] = this.navData.asrt_id;
      }
    } else {
      fltrData["selectedtenant"] = this.selectedtenant || 0;
      if (this.selectedtenant == 0 || !this.selectedtenant) {
        fltrData["sts_cd"] = this.sts_cd;
      }
      if (this.clap_in == 1 && this.selectedvndr) {
        fltrData["selectedvndr"] = this.selectedvndr;
      } else {
        fltrData["selectedvndr"] = 0;
      }
      if (this.selectedctgry && this.selectedtenant != 0) {
        fltrData["selectedctgry"] = this.selectedctgry;
      } else if (this.selectedctgry == 0) {
        fltrData["selectedctgry"] = this.selectedctgry;
      } else if (
        this.selectedctgry != 0 &&
        this.selectedtenant == 0 &&
        this.slctctgryNm == null
      ) {
        fltrData["selectedctgry"] = this.selectedctgry;
      } else {
        fltrData["selectedctgrynm"] = this.slctctgryNm;
      }
      if (this.selectedtenant != 0 && this.asrt_sts_id) {
        fltrData["asrt_sts_id"] = this.asrt_sts_id;
      } else if (this.selectedtenant == 0 && this.asrt_sts_id) {
        fltrData["sts_cd"] = this.sts_cd;
      }
    }
    // No pagination - fetch all vehicles
    fltrData["page"] = 0;
    fltrData["pageSize"] = 0;
    fltrData["searchText"] = this.searchText || "";
    fltrData["parkingFilter"] = this.parkingFilter || "";
    fltrData["locationFilter"] = this.locationFilter || "";

    this.apiSrvc
      .post(fltrData, "drivers/vehicles/vehicles")
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        if (res["status"] == 200) {
          var resData = res["data"];
          var vehicles = Array.isArray(resData) ? resData : resData.data || [];
          callback(vehicles);
        }
      });
  }

  export() {
    this.fetchAllVehicles((vehicles) => {
      this.exlArry = [];
      var count = 0;
      vehicles.forEach((obj) => {
        obj.sno = ++count;
        this.exlArry.push({
          Sno: obj.sno,
          ULB: obj.tnt_nm,
          "Vehicle Registration Number": obj.asrt_nm,
          "Vehicle Category": obj.asrt_ctgry_nm,
          "IMEI Number": obj.dev_imei_nu,
          "Driver Name": obj.crw_nm,
          "Driver Phone No": obj.crw_ph,
          "Vehicle Status": obj.asrt_sts_nm,
          "Data Last Received On": obj.data_received_ts,
        });
      });
      console.log(this.exlArry);
      // SECURITY (audit finding #9): neutralise formula-triggering values before
      // they reach the sheet. sanitizeRows returns new objects, so this.exlArry
      // and the grid bound to it are left untouched.
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
        sanitizeRows(this.exlArry)
      );
      const wb: XLSX.WorkBook = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer: any = XLSX.write(wb, {
        bookType: "xlsx",
        type: "array",
      });
      let fileName = "Vehicles-List";
      this.saveExcelFile(excelBuffer, fileName);
    });
  }
  saveExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: this.fileType });
    FileSaver.saveAs(data, fileName + this.fileExtension);
  }
  createPdf() {
    this.fetchAllVehicles((vehicles) => {
      let head = [];
      let data = [];
      head.push(
        { title: "Sno", dataKey: "sno" },
        { title: "ULB", dataKey: "ulb_nm" },
        { title: "Vehicle Registration Number", dataKey: "asrt_nm" },
        { title: "Vehicle Category", dataKey: "asrt_ctgry_nm" },
        { title: "IMEI Number", dataKey: "dev_imei_nu" },
        { title: "Driver Name", dataKey: "crw_nm" },
        { title: "Driver Phone No", dataKey: "crw_ph" },
        { title: "Vehicle Status", dataKey: "asrt_sts_nm" },
        { title: "Data Last Received On", dataKey: "data_received_ts" }
      );
      let keys = [
        "sno",
        "ulb_nm",
        "asrt_nm",
        "asrt_ctgry_nm",
        "dev_imei_nu",
        "crw_nm",
        "crw_ph",
        "asrt_sts_nm",
        "data_received_ts",
      ];
      for (var i = 0; i < vehicles.length; i++) {
        let row = [];
        vehicles[i].sno = i + 1;
        for (var j = 0; j < keys.length; ++j) {
          let key = keys[j];
          row.push(vehicles[i][key]);
        }
        data.push(row);
      }
      console.log(data);
      var pdfsize = "a4";
      var doc = new jsPDF("l", "mm", pdfsize);
      var width = doc.internal.pageSize.getWidth();
      var height = doc.internal.pageSize.getHeight();

      var logotx = "assets/images/logo/swatchAndraLgo.png";
      var rpt_hdr_tx = "SWACHHA ANDHRA CORPORATION";

      let selectedTntObj =
        this.tntLst && this.tntLst.length > 0 ? this.tntLst[0] : null;
      if (this.selectedtenant && this.selectedtenant !== 0 && this.tntLst) {
        const found = this.tntLst.find(
          (t: any) => t.tnt_id === this.selectedtenant
        );
        if (found) {
          selectedTntObj = found;
        }
      }

      if (
        this.userDtls?.clap_in == 1 &&
        this.clntDtls?.[0]?.tnts != 2000439 &&
        this.clntDtls?.[0]?.clnt_id == 7
      ) {
        logotx = "assets/images/logo/swatchAndraLgo.png";
        rpt_hdr_tx = "SWACHHA ANDHRA CORPORATION";
      } else if (
        (this.userDtls?.clap_in == 0 || this.userDtls?.clap_in == 2) &&
        this.clntDtls?.[0]?.tnts != 2000439 &&
        this.clntDtls?.[0]?.clnt_id == 7
      ) {
        logotx =
          selectedTntObj?.tnt_lgo_url_tx ||
          "assets/images/logo/swatchAndraLgo.png";
        rpt_hdr_tx =
          (selectedTntObj?.tnt_dsply_nm || "") + " Municipal corporation";
      } else if (this.clntDtls?.[0]?.clnt_id != 7) {
        logotx =
          this.clntDtls?.[0]?.clnt_lgo_url_tx ||
          "assets/images/logo/swatchAndraLgo.png";
        rpt_hdr_tx = this.clntDtls?.[0]?.clnt_nm || "";
      } else {
        rpt_hdr_tx = "SWACHHA ANDHRA CORPORATION";
      }

      var ovrall_wdth = 30;
      var ovrall_hgt = 25;

      doc.addImage(logotx, "PNG", 15, 5, ovrall_wdth, ovrall_hgt);
      doc.setTextColor("brown");
      doc.setFontSize(16);
      var fontSize = doc.getFontSize();
      var pageWidth = doc.internal.pageSize.width;
      // Calculate text's x coordinate
      var x = pageWidth / 2;
      doc.text(rpt_hdr_tx, x, 14, { align: "center" });
      doc.setTextColor("black");
      doc.setFontSize(12);
      var rpt_nm = "VehiclesList";
      doc.text(rpt_nm, x, 20, { align: "center" });
      doc.setTextColor("blue");
      // doc.setFontSize(11);
      doc.setTextColor("blue");
      (doc as any).autoTable({
        head: [head],
        body: data,
        theme: "grid",
        startY: 31,
        headStyles: { fillColor: [57, 50, 126], fontSize: 8 },
        bodyStyles: { fontSize: 8 },
        didDrawCell: (data) => {},
      });
      // Open PDF document in new tab
      doc.output("dataurlnewwindow");
      // Download PDF document
      doc.save("VehiclesList.pdf");
    });
  }
  cardchnge(sts) {
    console.log(sts);
    this.asrt_sts_id = sts;
    // Reset parking status filters when changing vehicle status
    this.activeStatusCard = "";
    this.activeLocationCard = "";
    this.parkingFilter = "";
    this.locationFilter = "";
    this.currentPage = 1;

    this.cardcntSummary.forEach((e) => {
      if (e.asrt_sts_id == sts) {
        this.sts_cd = e.asrt_sts_nm;
        console.log(this.sts_cd);
        e.crdChnge = true;
      } else {
        e.crdChnge = false;
      }
    });
    this.getVhclsLst();
  }
  /**
   * <app-data-grid> emits { row, column }, and only for data cells.
   *
   *   e.rowType === 'header'      -> dropped; the grid never emits for headers.
   *   e.data?.data || e.data      -> e.row, which is already the record.
   *
   * The `e.columnName === 'asrt_nm'` guard is deliberately NOT carried over.
   * `columnName` is not a property of DevExtreme's CellClickEvent (it exposes
   * `column`, with `dataField`/`caption`), so that comparison was
   * `undefined === 'asrt_nm'` - always false. The guard has never fired, and
   * clicking the vehicle-name column has always navigated.
   *
   * Translating it to `e.column?.dataField === 'asrt_nm'` would have been the
   * obvious rewrite and would have SILENTLY ACTIVATED dormant code, changing
   * behaviour users rely on. A migration preserves what the app does, not what
   * it looks like it meant to do. If the guard was intended, re-enable it as a
   * deliberate change with its own test.
   */
  onCellClick(e: { row: any; column: any }) {
    this.gotovehcleDashboard(e.row);
  }

  ngOnDestroy(): void {
    // Cancel all pending HTTP requests
    this.destroy$.next();
    this.destroy$.complete();
    // Unsubscribe all tracked subscriptions
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    this.subscriptions = [];
    // Remove window resize listener
    if (this.resizeListener) {
      window.removeEventListener("resize", this.resizeListener);
      this.resizeListener = null;
    }
    // Clear data arrays
    this.vhcleslst = [];
    this.vehDupLst = [];
    this.cardcntSummary = [];
    this.ctgryCardcntSummary = [];
  }

  goBackToDashboard() {
    this.router.navigate([`internal/dashboard/urban-dashboard`]);
  }
}
